import { render } from "./CallStackItem.vue?vue&type=template&id=7a2ef7e8"
import script from "./CallStackItem.vue?vue&type=script&lang=js"
export * from "./CallStackItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__